const HIERARCHICAL_SEPARATOR = ' > ';

export const isStrictAncestorOfCurrent = (value: string, currentPath: string[]): boolean => {
  const itemPath = value.split(HIERARCHICAL_SEPARATOR);
  if (itemPath.length >= currentPath.length) {
    return false;
  }
  return itemPath.every((id, index) => id === currentPath[index]);
};

export const handleHierarchicalItemClick = (
  refine: (value: string) => void,
  currentPath: string[],
  value: string,
): void => {
  if (isStrictAncestorOfCurrent(value, currentPath)) {
    refine(value);
  }
  refine(value);
};
